import {Loader} from "@modules/my-ratings/components/loader/loader.style";

export const LoaderComponent = () => {
  return (
    <Loader>
      <span className="loader"></span>
    </Loader>
  )
}
